import {
  ApplicationConfig,
  ErrorHandler,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { GlobalErrorHandler, HttpLoadingInterceptor, HttpResilienceInterceptor, provideMsalAuth } from '#core';
import { provideWorkflowEngineGateway } from '#services';
import { routes } from './app.routes';
import { appInitializer } from './app-initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideCharts(withDefaultRegisterables()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAppInitializer(appInitializer),
    // Registered before provideMsalAuth() so its first-event cap bounds the token wait.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoadingInterceptor,
      multi: true,
    },
    provideMsalAuth(),
    // Registered after provideMsalAuth() so the per-attempt timeout and retry start once the token is attached.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpResilienceInterceptor,
      multi: true,
    },
    provideWorkflowEngineGateway(),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
};
